import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InsuranceFund  {
    _originalTypeClassName = "zERP.BO.InsuranceFund";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InsuranceFund.translate = translateService;
}
this.Representatives = [];
this.Id = null;
this.InsuranceAgency = null;
this.RegionalAgency = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
InsuranceAgency:any;
RegionalAgency:any;
Representatives:any;
static setRepresentatives = ($this, items) => {
                if (items == null) items = [];
                if ($this.Representatives == null) $this.Representatives = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Representatives.length > 0) {
                    Domain.InsuranceFund.removeRepresentatives($this, $this.Representatives[0]);
                }

                Domain.InsuranceFund.addManyRepresentatives($this, copyItems);
            }
static addManyRepresentatives = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InsuranceFund.addRepresentatives($this, items[i]);
                }
            }
static addRepresentatives = ($this, item) => {
                if ($this.Representatives == null) $this.Representatives = [];
                if (item == null || $this.Representatives.indexOf(item) > -1) return;
                $this.Representatives.push(item);
}
static addRangeRepresentatives = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InsuranceFund.addRepresentatives($this, item));
            }
static removeRepresentatives = ($this, item) => {
                if ($this == null || $this.Representatives == null || $this.Representatives.indexOf(item) === -1) return;
                var _index = $this.Representatives.indexOf(item);
                $this.Representatives.splice(_index, 1);
}
static clearRepresentatives = ($this) => { $this.Representatives = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}